import { useSelector } from 'react-redux'

import { ROLES } from '../constants'

/**
 * Hook global de permisos de la aplicación.
 *
 * Centraliza la lógica de "perfil con permisos extendidos" (Prescriptor) para evitar
 * condicionales repetidos por toda la aplicación (NEVO-439 - Limitar ACVC post portal único).
 *
 * A partir del portal único, la gestión de demandas y solicitudes (peticiones, datos de
 * potencial, alta de tarifas/usuarios, etc.) queda restringida para todos los perfiles,
 * con la única excepción del perfil Prescriptor (`administrador_prescriptor`).
 *
 * @returns {{ role: string, isPrescriptor: boolean, hasExtendedPermissions: boolean }}
 */
export const usePermissions = () => {
  const role = useSelector((state) => state.global.role)

  const isPrescriptor = role === ROLES.ADMINISTRADOR_PRESCRIPTOR.KEY

  return {
    role,
    isPrescriptor,
    // El perfil Prescriptor es, por ahora, el único con permisos extendidos de gestión.
    hasExtendedPermissions: isPrescriptor,
  }
}
